var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiGovernanceUntracked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.41 26L31 22.41L29.59 21L26 24.59L22.41 21L21 22.41L24.59 26L21 29.59L22.41 31L26 27.41L29.59 31L31 29.59zM16 23l-2.139-1.013A5.022 5.022 0 0 1 11 17.467V11h10v6.468a5.021 5.021 0 0 1-2.861 4.52zm-3-10v4.468a3.01 3.01 0 0 0 1.717 2.71l1.283.608l1.283-.607A3.012 3.012 0 0 0 19 17.468V13zm-8.88 4.656A2 2 0 1 0 1 16c0 .789.46 1.464 1.124 1.79a13.946 13.946 0 0 0 9.569 11.535l.614-1.904a11.954 11.954 0 0 1-8.186-9.765m25.756-3.446a13.946 13.946 0 0 0-9.569-11.535l-.614 1.904a11.954 11.954 0 0 1 8.186 9.765A2 2 0 1 0 31 16a1.992 1.992 0 0 0-1.123-1.79M16 1c-.789 0-1.464.46-1.79 1.124a13.947 13.947 0 0 0-11.535 9.568l1.904.616a11.954 11.954 0 0 1 9.765-8.187A2 2 0 1 0 16 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiGovernanceUntracked);
export default __webpack_public_path__ + "static/media/ai-governance-untracked.ec3955d2386e52ba98113a57de547c4b.svg";
export { ForwardRef as ReactComponent };